<div class="work-interval">
  <div class="grid grid--gap-4">
    <div class="grid__box grid__box--size-6">
      <div *ngIf="intervals['expiration-time'] && (intervals['expiration-time'].hours || intervals['expiration-time'].minutes)">
        <div class="grid grid--gap-4 grid--va-middle">
          <div class="grid__box grid__box--size-min">
            <div class="work-shift-interval-square {{ 'work-shift-interval-square--' + Enums.workShiftIntervalSquare[3] }}"></div>
          </div>
          <div class="grid__box grid__box--size-min">
            <span *ngIf="intervals['expiration-time'].hours">{{ intervals['expiration-time'].hours }}ч </span>
            <span *ngIf="intervals['expiration-time'].minutes">{{ intervals['expiration-time'].minutes }} м</span>
          </div>
        </div>
      </div>
    </div>
    <div class="grid__box grid__box--size-6">
      <div *ngIf="intervals['work-time'] && (intervals['work-time'].hours || intervals['work-time'].minutes)">
        <div class="grid grid--gap-4 grid--va-middle">
          <div class="grid__box grid__box--size-min">
            <div class="work-shift-interval-square {{ 'work-shift-interval-square--' + Enums.workShiftIntervalSquare[1] }}"></div>
          </div>
          <div class="grid__box grid__box--size-min">
            <span *ngIf="intervals['work-time'].hours">{{ intervals['work-time'].hours }}ч </span>
            <span *ngIf="intervals['work-time'].minutes">{{ intervals['work-time'].minutes }}м</span>
          </div>
        </div>
      </div>
    </div>
    <div class="grid__box grid__box--size-6 grid__box--pull-right">
      <div *ngIf="intervals['lunch-time'] && (intervals['lunch-time'].hours || intervals['lunch-time'].minutes)">
        <div class="grid grid--gap-4 grid--va-middle">
          <div class="grid__box grid__box--size-min">
            <div class="work-shift-interval-square {{ 'work-shift-interval-square--' + Enums.workShiftIntervalSquare[2] }}"></div>
          </div>
          <div class="grid__box grid__box--size-min">
            <span *ngIf="intervals['lunch-time'].hours">{{ intervals['lunch-time'].hours }}ч </span>
            <span *ngIf="intervals['lunch-time'].minutes">{{ intervals['lunch-time'].minutes }}м</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
